import React from 'react';

import { RequestsTableConsumer } from 'src/components/reports';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const RequestsReportPage: React.FC = () => {
  return (
    <TableDataProvider>
      <RequestsTableConsumer />
    </TableDataProvider>
  );
};
